import { StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from "react-router/dom";


import reportWebVitals from "./reportWebVitals.js";


import "./index.css";

hydrateRoot(
    document,
    <StrictMode>
        <HydratedRouter />
    </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
